import { get } from 'helpers/api';
import axios from 'axios';

const path = (token: string) => `/client_reports/${token}/metrics`;
const fastPath = (token: string) => `/client_reports/${token}/fast_metrics`;
const analyticsPath = (token: string) => `/client_reports/${token}/analytics`;

export function fetchMetrics(token: string, startDate: string): Promise<any> {
  return get(path(token), { params: { startDate } });
}

export function fetchFastMetrics(token: string, startDate: string, endDate: string = ''): Promise<any> {
  return get(fastPath(token), { params: { startDate, endDate } });
}

export function fetchAnalyticsMetrics(token: string, startDate: string, endDate: string = ''): Promise<any> {
  return get(analyticsPath(token), { params: { startDate, endDate } });
}

export function uploadClientReportCardImage(projectId: number, id: number, image: File, config?: any) {
  const formData = new FormData();
  formData.append('file', image);
  formData.append('email_ca', '1');

  return axios.post(
    `/projects/${projectId}/client_report_cards/${id}/add_image`,
    formData,
    config
  );
}
